var $ = window.jQuery = require('jquery');

$(document).ready(function () {

	window.jQuery('.fancybox').fancybox({
		type: 'image',
		margin: [140, 10, 10, 10]
	});

});
